import React from 'react';
import classnames from 'classnames';

export default function StateChangeButtonComponent({ by, disabled, onClick }) {
  return (
    <button
      type="button"
      className={classnames(
        'button button--primary exchange-ui__state-change-button',
        disabled && 'button--disabled',
      )}
      disabled={disabled}
      onClick={() => onClick(by)}
    >
      {+by > 0 && '+'}
      {by}
    </button>
  );
}